import * as z from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { relationshipScoreQuerySchema } from './relationship-score-query-schema';

export const relationshipScoreUpdateSchema = relationshipScoreQuerySchema
  .pick({ id: true, label: true, number: true })
  .extend({ status: statusMutationSchema, icon: z.array(z.number()).nullable() });

export type RelationshipScoreUpdateSchema = z.infer<typeof relationshipScoreUpdateSchema>;

export const relationshipScoreCreateSchema = relationshipScoreUpdateSchema.omit({
  id: true,
  icon: true,
});

export type RelationshipScoreCreateSchema = z.infer<typeof relationshipScoreCreateSchema>;
